import {DealsDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { getDealByIdSchema } from './_schema/getDealById.schema';
const FUNCTION_CODE = 'GET_DEAL_BY_ID';

export async function getDealById(userData: Record<string, string>, id: number) {
    try {

        const deal = await DealsDao.getDealById(userData.userToken, id);

        const parsedResult = getDealByIdSchema.parse(deal);

        return parsedResult;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
